import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="container-page py-14 md:py-20">
      <SectionHeading
        kicker="Categories"
        title="按题材进入"
        desc="六个编辑分类，从家庭结构到职场组织，每一条线索都指向不同的伦理命题。"
        action={
          <Link
            to="/category/ethics-drama"
            className="hidden items-center gap-1.5 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-accent-700 md:inline-flex"
          >
            全部分类 <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat, index) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group relative flex min-h-[176px] overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-accent-300"
          >
            <div className="relative flex flex-1 flex-col justify-between p-5">
              <div>
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${cat.icon} text-[15px]`} />
                  </span>
                  <span className="font-label text-[10px] tracking-[0.2em] text-foreground-400">
                    {String(index + 1).padStart(2, "0")} / {cat.en.toUpperCase()}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950 transition-colors group-hover:text-primary-800">
                  {cat.name}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">{cat.desc}</p>
              </div>
              <span className="mt-4 inline-flex items-center gap-1 text-xs text-accent-700">
                查看分类 <i className="ri-arrow-right-up-line" />
              </span>
            </div>
            <div className="relative w-[38%] shrink-0 overflow-hidden">
              <img
                src={cat.cover}
                alt={`${cat.name} 分类封面`}
                title={`${cat.name} 日本伦理剧分类`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/20 to-transparent" />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}